import addError from '../../../utils/error.jsx';
import { request as getRoles } from '../actions/get';

export function request(data) {
    return {
        type: 'ROLE_UPDATE_REQUEST',
        data
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'ROLE_UPDATE_ERROR',
        errors
    };
}

export function finish(data) {
    return (dispatch) => {
        dispatch(getRoles());
        dispatch({
            type: 'ROLE_UPDATE_FINISH',
            data
        });
    };
}
